<!-- PAGE LOADER -->
<div class="page-progress" *ngIf="moduleLoading">
  <ngb-progressbar [value]="progressValue" [striped]="false" [animated]="true" />
</div>

<router-outlet />
